<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    import $ from 'jquery'

    export default {
        name: 'app',
        components: {
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            hubConection() {
                return this.$store.state.hubConection
            },
        },
        mounted: function () {
            $(this.$refs.vuemodal).on("hidden.bs.modal", function () {
                alert('hide');
                $("html").removeClass('modal-open');
            })
            $(this.$refs.vuemodal).on("shown.bs.modal", function () {
                alert('show');
                $("html").addClass('modal-open');
            })
                        
        },
    };
</script>

<style >
    .m-modal-body {
        position: unset !important;
    }

    .modal-open{
        overflow: hidden !important;
    }

    .popover-body {
        max-width: 32vw !important;
        
    }
        .popover-body p, .popover-body span {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box !important;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 25;
            margin-bottom: unset;
        }
</style>

